import { styled } from '@mui/material';
import { Form } from 'formik';

export const StyledStepsCreateStep2Form = styled(Form)({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	justifyContent: 'center',
});

export const StyledStepsCreateStep2FormItems = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '32px',
	minWidth: '600px',

	'& ul': {
		paddingInline: '32px',
	},

	[theme.breakpoints.down('sm')]: {
		gap: '8px',
		minWidth: '0px',
	},
}));
